import React from 'react';
import { Link } from 'react-router-dom';
import './FooterSection.scss';

const FooterSection = props => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="cv-landing-page-footer-section">
      <div className="cv-landing-page-footer-header">
        <p>
          <span className="cv-footer-header-text">
            Find your winning moment
          </span>
          <span className="footer-registered-icon">
            <sup>&#174;</sup>
          </span>
        </p>
      </div>

      <div className="cv-landing-page-footer-links">
        <footer>
          <div className="footer-column footer-column-1">
            <h4>WIND CREEK HOSPITALITY</h4>
            <div>
              <address className="field-description">
                <p>303 Poarch Rd.</p>
                <p>Atmore, AL 36502</p>
                <a href="tel:+1-866-946-3360">
                  <span> (866) 946-3360</span>
                </a>
              </address>
            </div>
            <p>Gambling Problem? Call 1-800-Gambler.</p>
            <div className="footer-links">
              <ul>
                <li>
                  <Link to="/support">Contact us</Link>
                </li>
                <li>
                  <a href="https://windcreek.com/community-support">
                    Community Support
                  </a>
                </li>
                <li>
                  <Link to="/privacy">Privacy Policy</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-column footer-column-2">
            <div className="footer-links">
              <ul>
                <li>
                  <a href="https://windcreek.com/careers">Careers</a>
                </li>
                <li>
                  <a href="https://windcreek.com/hospitality">About Us</a>
                </li>
                <li>
                  <a href="https://windcreek.com/news">News</a>
                </li>
                <li>
                  <a href="https://windcreek.com/find-lucky-bill">
                    Casinoverse Welcome
                  </a>
                </li>
                <li>
                  <Link title="Responsible Gaming" to="/responsible-gaming">
                    Responsible Gambling
                  </Link>
                </li>
                <li>
                  <a href="https://windcreek.com/rewards">Rewards</a>
                </li>
                <li>
                  <a href="https://pci-nsn.gov/">Poarch Creek Tribe</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-column footer-column-3">
            <h4>Wind Creek Locations</h4>
            <div>
              <ul className="footer-links nav-tertiary nav-tertiary-1">
                <li>
                  <a title="Atmore" href="https://windcreek.com/atmore">
                    Atmore
                  </a>
                </li>
                <li>
                  <a title="Aruba" href="https://windcreek.com/aruba">
                    Aruba
                  </a>
                </li>
                <li>
                  <a title="Bethlehem" href="https://windcreek.com/bethlehem">
                    Bethlehem
                  </a>
                </li>
                <li>
                  <a title="Curacao" href="https://windcreek.com/curacao">
                    Curaçao
                  </a>
                </li>
                <li>
                  <a title="Montgomery" href="https://windcreek.com/montgomery">
                    Montgomery
                  </a>
                </li>
                <li>
                  <a
                    title="Chicago Southland"
                    href="https://windcreek.com/chicagosouthland"
                  >
                    Chicago Southland
                  </a>
                </li>
                <li>
                  <a title="Wetumpka" href="https://windcreek.com/wetumpka">
                    Wetumpka
                  </a>
                </li>
              </ul>
              <ul className="footer-links nav-tertiary nav-tertiary-2">
                <li>
                  <a title="Gretna" href="https://www.creekentertainment.com/">
                    Gretna
                  </a>
                </li>
                <li>
                  <a
                    title="Pensacola"
                    href="https://www.pensacolagreyhoundtrack.com/"
                  >
                    Pensacola
                  </a>
                </li>
                <li>
                  <a title="Mobile" href="https://www.mobilegreyhoundpark.com/">
                    Mobile
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </footer>
        <div className="footer-contact">
          <Link title="contact" to="/support">
            Contact
          </Link>
        </div>
        <div className="footer-copyright">
          <p>Copyright &copy; {currentYear} Wind Creek Hospitality</p>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;
